import '../init-sentry';

// eslint-disable-next-line import/order
import * as Sentry from '@sentry/react';

Sentry.setTag('app', 'client-app');

import React from 'react';
import { App as AntdApp } from 'antd';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import ReactDOM from 'react-dom/client';
import { initDevMode } from '../services/dev-mode/dev-mode';
import ClientApp from './client-app';
import '../i18n.ts';
import '../index.css';

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AntdApp>
      <QueryClientProvider client={queryClient}>
        <ClientApp />
        <ReactQueryDevtools />
      </QueryClientProvider>
      {initDevMode()}
    </AntdApp>
  </React.StrictMode>,
);
